// extracted by mini-css-extract-plugin
export default {"deleteGroupModal":"DeleteGroup_deleteGroupModal__Y-p5K"};